var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-client--container no-select"},[_c('fields-client',{attrs:{"search":_vm.search,"reset":_vm.reset,"submit":_vm.submitAdd},on:{"submit":_vm.addClient}}),_c('div',{staticClass:"btn btn-sm btn-success",on:{"click":_vm.addSubmit}},[_vm._v("Сохранить")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }